
import { Component, Vue } from 'vue-property-decorator';
import config from '@/config';

@Component({
  name: 'RGPDEcomotiveApp',
})
export default class RGPDEcomotiveApp extends Vue {
  mounted() {
    // Redirect to home page if the app name is not Ecomotive
    const name = config.nameApp || "";
    if (name.toLowerCase() !== "ecomotive") {
      this.$router.push({ path: '/' });
    }
  }
}
